import { RemoteGetAllEvaluationCriteria } from 'data/usecases';
import { makeApiUrlEvaluationCriteria } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetAllEvaluationCriteria =
  (): RemoteGetAllEvaluationCriteria => {
    return new RemoteGetAllEvaluationCriteria(
      makeApiUrlEvaluationCriteria(),
      makeAxiosHttpClient(),
    );
  };
